/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { completeSignUpWithValidation } from 'state/actions/auth_status';
import { updateAgreementInfo } from 'state/actions/session_status';
import { getCommentingEmailIfExist } from 'state/actions/commentingState/commentingStatus';
import { displayMessage, displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui'; // iui-utils
// component
import CompleteSignUp from 'pages/auth/completesignup/completesignup';



/* ========== ~~~~~~~~~~ AUTH COMPLETE SIGNUP : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ authStatus, sessionStatus, commentingState }) => ({
    completesignup: authStatus.completesignup,
    fields: authStatus.completesignup.fields,
    userUUID: sessionStatus.userUUID,
    userEmail: sessionStatus.userEmail,
    showTermsAndConditions: sessionStatus.showTermsAndConditions,
    agreementUUID: sessionStatus.agreementUUID,
    commentingEmailAlreadyExist: commentingState.commentingStatus.commentingEmailAlreadyExist
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    displayMessage: message => dispatch(displayMessage(message)),
    completeSignUpWithValidation: (fields, callData, successAction, failAction) => dispatch(completeSignUpWithValidation(fields, callData, successAction, failAction)),
    displayErrorMessage: errorMessage => dispatch(displayErrorMessage(errorMessage)),
    displaySuccessMessage: successMessage => dispatch(displaySuccessMessage(successMessage)),
    updateAgreementInfo: (agreementUUID, userUUID, callback) => dispatch(updateAgreementInfo(agreementUUID, userUUID, callback)),
    getCommentingEmailIfExist: email => dispatch(getCommentingEmailIfExist(email))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompleteSignUp);
